export default "/images/ship-icon.png?4280428894fc90ffc72ce04912ea96d0";